import { apiDelete } from "../client";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { QueryKeys } from "@/lib/query-keys";

export const deleteExamPaper = async (id: string) => {
  const response = await apiDelete(`/exam_papers/${id}`);
  return response.data;
};

export const useDeleteExamPaper = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id: string) => deleteExamPaper(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [QueryKeys.examPaper.list] });
    },
  });
};
